// Auto-generated file created by svgr-cli source svg-template.js
// Run yarn icons:create to update
// Do not edit
import * as React from 'react'
import { SVGProps } from 'react'
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
    <svg fill='none' height={props.height || 16} role='img' viewBox='0 0 20 20' width={props.width || 16} xmlns='http://www.w3.org/2000/svg' {...props}>
        <path
            d='M10 18.333A8.333 8.333 0 0 0 18.334 10 8.333 8.333 0 0 0 10 1.667 8.333 8.333 0 0 0 1.667 10 8.333 8.333 0 0 0 10 18.333ZM7.364 7.363a.778.778 0 0 1 1.103 0l1.53 1.53 1.53-1.53a.78.78 0 0 1 1.104 1.104l-1.53 1.53 1.53 1.53a.781.781 0 0 1-1.104 1.104l-1.53-1.53-1.53 1.53a.78.78 0 0 1-1.104-1.104l1.53-1.53-1.53-1.53a.778.778 0 0 1 0-1.104Z'
            fill='currentcolor'
        />
    </svg>
)
export default SvgClose
